const BASE_URL = 'https://thoughtic.com';

const PATH_LABELS: Record<string, string> = {
  '': 'Home',
  'about': 'About',
  'services': 'Services',
  'industries': 'Industries',
  'technologies': 'Technologies',
  'talent': 'Talent Solutions',
  'how-it-works': 'How It Works',
  'case-studies': 'Case Studies',
  'trust-security': 'Trust & Security',
  'careers': 'Careers',
  'faq': 'FAQ',
  'pricing': 'Pricing',
  'blog': 'Blog',
  'leadership': 'Leadership',
  'software-development': 'Software Development',
  'talent-solutions': 'Talent Solutions',
  'hire-react-developers': 'Hire React Developers',
  'hire-python-developers': 'Hire Python Developers',
  'hire-nodejs-developers': 'Hire Node.js Developers',
  'offshore-development-team-india': 'Offshore Development Team India',
  'dedicated-development-team': 'Dedicated Development Team',
  'saas': 'SaaS',
  'fintech': 'Fintech',
  'healthtech': 'Healthtech',
  'ecommerce': 'Ecommerce',
  'logistics': 'Logistics',
  'edtech': 'EdTech',
};

interface BreadcrumbItem {
  '@type': 'ListItem';
  position: number;
  name: string;
  item: string;
}

interface BreadcrumbListSchema {
  '@context': 'https://schema.org';
  '@type': 'BreadcrumbList';
  itemListElement: BreadcrumbItem[];
}

export function generateBreadcrumbSchema(pathname: string): BreadcrumbListSchema {
  const cleanPath = pathname.replace(/\/$/, '') || '/';

  if (cleanPath === '/') {
    return {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: 'Home',
          item: BASE_URL,
        },
      ],
    };
  }

  const segments = cleanPath.split('/').filter(Boolean);
  const itemListElement: BreadcrumbItem[] = [
    {
      '@type': 'ListItem',
      position: 1,
      name: 'Home',
      item: BASE_URL,
    },
  ];

  let accumulatedPath = '';
  for (let i = 0; i < segments.length; i++) {
    accumulatedPath += `/${segments[i]}`;
    const label = PATH_LABELS[segments[i]] || segments[i].replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
    itemListElement.push({
      '@type': 'ListItem',
      position: i + 2,
      name: label,
      item: `${BASE_URL}${accumulatedPath}`,
    });
  }

  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement,
  };
}

export function injectBreadcrumbSchema(pathname: string): void {
  const schema = generateBreadcrumbSchema(pathname);
  let scriptEl = document.querySelector('script[data-schema="breadcrumb"]') as HTMLScriptElement | null;
  if (!scriptEl) {
    scriptEl = document.createElement('script');
    scriptEl.type = 'application/ld+json';
    scriptEl.setAttribute('data-schema', 'breadcrumb');
    document.head.appendChild(scriptEl);
  }
  scriptEl.textContent = JSON.stringify(schema);
}